import { render, staticRenderFns } from "./DialogProjectsTeamEditMoney.vue?vue&type=template&id=b5a3a4b4&"
import script from "./DialogProjectsTeamEditMoney.vue?vue&type=script&lang=js&"
export * from "./DialogProjectsTeamEditMoney.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports